import { render } from "./MemberFooter.vue?vue&type=template&id=45350bda&scoped=true"
import script from "./MemberFooter.vue?vue&type=script&lang=js"
export * from "./MemberFooter.vue?vue&type=script&lang=js"

import "./MemberFooter.vue?vue&type=style&index=0&id=45350bda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45350bda"]])

export default __exports__